<div class="flex flex-1 flex-row">
	<div class="w-1/2">
		<p class="text-2xl font-bold">HCRA Oversight Regulatory Fee</p>
		<div class="mr-5 flex flex-col gap-5">
			<app-radio-group
				class="mt-3"
				[items]="creditItems"
				label="Credit"
				name="area"
				[(ngModel)]="adjustment.credit"
				(ngModelChange)="changed()"
				type="compact"
			></app-radio-group>

			<div>
				<p>Enrolment date</p>
				<p class="font-bold">On or after February 01, 2021</p>
			</div>

			<app-checkbox
				*ngIf="adjustment.credit !== 'none'"
				label="Apply HST ({{ hst | percent }})"
				[(ngModel)]="adjustment.applyHst"
				(ngModelChange)="changed()"
				[disabled]="adjustment.credit === 'none'"
				class="w-fit"
			></app-checkbox>

			<app-input
				*ngIf="creditAmount >= 0"
				type="cents"
				label="Credit vendor"
				name="credit"
				[startIcon]="ICON.DOLLAR"
				[ngModel]="creditAmount"
				[disabled]="true"
			></app-input>
			<app-input
				*ngIf="creditAmount < 0"
				type="cents"
				label="Credit purchaser"
				name="credit"
				[startIcon]="ICON.DOLLAR"
				[ngModel]="creditAmount * -1"
				[disabled]="true"
			></app-input>

			<div>
				<app-checkbox
					label="Include all details in document"
					[(ngModel)]="adjustment.details"
					type="clear"
				></app-checkbox>
			</div>

			<div class="flex justify-between mr-5">
				<app-button btn="tertiary" class="mr-5" (click)="cancelModal()"
					>Cancel</app-button
				>
				<app-button (click)="saveModal()">Save</app-button>
			</div>
		</div>
	</div>

	<div class="w-1/2">
		<app-container type="dark" title="Details">
			<div class="flex flex-1 flex-col">
				<div class="mb-8">
					<div *ngIf="adjustment.credit !== 'none'">
						<div class="flex justify-between items-start mb-3">
							<div>Enrolment fee</div>
							<div>{{ enrolmentFee | centsToDollars }}</div>
						</div>
						<div
							*ngIf="adjustment.applyHst"
							class="flex justify-end items-start mb-8"
						>
							<div>
								<strong
									>HST ({{ hst | percent }}) =
									{{ hstAmount | centsToDollars }}</strong
								>
							</div>
						</div>
						<div class="flex justify-end items-start">
							<div *ngIf="creditAmount > 0">
								<strong
									>Credit Vendor = {{ creditAmount | centsToDollars }}</strong
								>
							</div>
							<div *ngIf="creditAmount < 0">
								<strong
									>Credit Purchaser =
									{{ creditAmount * -1 | centsToDollars }}</strong
								>
							</div>
						</div>
					</div>
					<div *ngIf="adjustment.credit === 'none'">
						<div class="flex justify-end items-start mb-8">
							<div>No adjustment</div>
						</div>
					</div>
				</div>
			</div>
		</app-container>
	</div>
</div>
